import React, { useEffect } from "react";
import InvoiceCard from "./common/InvoiceCard";
import Footer from "./Footer";
import HeaderInner from "./HeaderInner";
import configureStore from "../../../store/configureStore";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { get_credit_note } from "./actions/action-creditNote";
import CommonSnackBar from "../../common/CommonSnackBar";
import { history } from "../../../reducers";
import AddIcon from "@material-ui/icons/Add";
import CreditNoteCard from "./common/CreditNoteCard";

const store = configureStore();

function CreditNoteList() {
  const dispatch = useDispatch();
  const { activeOuid } = store.getState().permission;
  const { creditNote, showGlobalLoader } = useSelector(
    (state) => state.creditNote
  );

  function renderList(creditNote) {
    if (creditNote) {
      return creditNote.map((item) => (
        <CreditNoteCard key={item.id} item={item} />
      ));
    } else {
      return <>No credit Note found</>;
    }
  }

  useEffect(() => {
    console.log("inuseEffect");
    const fetchData = async (dispatch) => {
      await dispatch(get_credit_note(activeOuid));
    };
    fetchData(dispatch);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="Credit Notes " />
      <div className=" HrmAppPage container--narrow mt FBAppPage">
        {showGlobalLoader ? <Loader /> : renderList(creditNote)}

        <div className="AppFloatingButtonWrapper t-r">
          <button
            className="round_btn bg_blue "
            onClick={() => history.push(`/${activeOuid}/create-credit-note`)}
          >
            <AddIcon />
          </button>
        </div>
      </div>
      <Footer />
      <CommonSnackBar />
    </div>
  );
}

export default CreditNoteList;
